module.exports = __webpack_public_path__ + "components/flag/static/square/ve-ede15c2583ace31d82494dd839755767.svg";